module.exports = __webpack_public_path__ + "img/2024-10-16d_2.d1cc4f38.jpg";